import BasicTabs from 'components/profileTab/ProfileTabs'
import React from 'react'
import { useLocation, useParams } from 'react-router-dom'
import styles from "./Profile.module.scss"
import CreateProfile from './CreateProfile'
import Notifications from './Notifications'
import Devices from './Devices'
const Profile = () => {
    const { tabs } = useParams()
    const location = useLocation()

    const renderContent = () => {
        switch (tabs) {
            case "profile":

                return <CreateProfile />
            case "notifications":

                return <Notifications />
            case "devices":

                return <Devices />

            default:
                return <CreateProfile />
        }
    }
    return (
        <>
            <div className={styles?.mainContainer}>
                {/* <BasicTabs /> */}
                <div className={styles?.mainForm} style={{
                    width: location?.pathname == "/settings/devices" ? "100%" :
                        ""
                }}>
                    {
                        renderContent()
                    }
                </div>
            </div>
        </>
    )
}

export default Profile